import 'isomorphic-fetch';
import * as Constants from './../constants/Constants';

const host = Constants.getHost();

export function getPlaces() {
    return fetch(`${host}/places`)
        .then(response => response.json())
        .then(json => {
            return json;
        })
        .catch(error => {
            console.log('error', error);
            return error;
        });
}

export function getMessages() {
    console.log(host);
    return fetch(`${host}/messages.json`)
        .then(response => response.json())
        .then(json => {
            return json;
        })
        .catch(error => {
            console.log('error', error);
            return error;
        });
}

// export function getVideos() {
//     return fetch(`${host}/videos`)
//         .then(response => response.json())
//         .then(json => {
//             return json;
//         })
//         .catch(error => {
//             console.log('error', error);
//             return error;
//         });
// }

export function getContents() {
    // return fetch(`${host}/contents`)
    return fetch(`${host}/contents.json`)
        .then(response => response.json())
        .then(json => {
            return json;
        })
        .catch(error => {
            console.log('error', error);
            return error;
        });
}

export function getMenus() {
    return fetch(`${host}/menus.json`)
        .then(response => response.json())
        .then(json => {
            return json;
        })
        .catch(error => {
            console.log('error', error);
            return error;
        });
}




